<template>
  <div class="card shadow-4 h-100">
    <div class="card-body">
      <h3 class="text-uppercase text-primary mb-5 pl-5">Économisez</h3>
      <p class="card-description mb-6">Optez pour un abonnement annuel et profitez de 2 mois offerts</p>
      <div class="row">
        <!-- MONTHLY -->
        <div class="col-5">
          <div class="h-100 d-flex align-items-center">
            <!-- <div class="card border border-primary"> -->
            <div class="border border-primary h-75 w-100">
              <div class="card-body h-100 p-0">
                <h6 class="text-primary text-uppercase text-center border-bottom border-primary">Mensuel</h6>
                <div class="h-75 d-flex align-items-center justify-content-center">
                  <div>
                    <h4 class="text-center font-weight-bold text-dark" style="font-size: 1.3rem">
                      {{ number_format(currentPlan.price) }} €
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- YEARLY -->
        <div class="col-7" style="position: relative">
          <p class="lead-7 text-primary" style="position: absolute; top: 35%; left: -7%"><i class="fas fa-arrow-alt-right"></i></p>
          <div class="border border-primary h-100">
            <div class="card-body h-100 p-0">
              <h5 class="text-white bg-primary text-uppercase d-flex align-items-center justify-content-center" style="height: 3rem">Annuel</h5>
              <div>
                <h4 class="text-center font-weight-bold text-dark mt-6" style="font-size: 1.5rem">
                  {{ yearlyPlan.price / 12 }} €
                </h4>
                <p class="text-center text-muted mb-0">Par mois par utilisateur</p>
                <p class="text-center">2 mois offerts</p>
              </div>
              <div class="text-center my-6">
                <a :href="`${baseUrl}?plan=${yearlyBillingPlan}&users=${premiumMaxUsers}#checkout`">
                  <button class="btn btn-round btn-primary w-75">Choisir</button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-4">
        <p class="text-center">
          Vous économisez <span class="text-primary font-weight-bold">{{ savingForAllUsers }} €</span> par an pour vos {{ premiumMaxUsers }} utilisateurs
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import { printLang } from '../lang';

  export default {
    props: {
      user: { type: Object, required: true },
      availablePlans: { type: Object, required: true },
    },
    computed: {
      billingPlan() { return this.user.company && this.user.company.billing_plan; },
      yearlyBillingPlan() { return `${this.billingPlan}12M`; },
      currentPlan() { return this.availablePlans[this.billingPlan]; },
      yearlyPlan() { return this.availablePlans[this.yearlyBillingPlan]; },
      premiumMaxUsers() { return this.user.company && this.user.company.maxusers; },
      savingForAllUsers() {
        const planSaving = this.currentPlan.price - this.yearlyPlan.price / 12;
        return this.number_format(planSaving * 12 * this.premiumMaxUsers);
      },
      baseUrl() { return printLang('Url'); },
    },
    methods: {
      number_format(nbr) {
        let nbrFixed = nbr.toFixed(2);
        if (nbrFixed.endsWith('.00')) nbrFixed = nbrFixed.slice(0, -3);
        const nbrFormated = nbrFixed.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        return nbrFormated.replace('.', ',');
      },
    },
  };
</script>
